import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
var Address = function Address(_ref) {
  var _address$country;
  var address = _ref.address,
    deleteAddress = _ref.deleteAddress;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-4",
    key: address.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-light mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(T, {
    source: "address-label-".concat(address.label)
  })), address.name, /*#__PURE__*/React.createElement("div", null, address.organization || ''), /*#__PURE__*/React.createElement("div", null, address.address1 || ''), /*#__PURE__*/React.createElement("div", null, address.address2 || ''), /*#__PURE__*/React.createElement("div", null, "".concat(address.city || '', ", ").concat(address.state || '', " ").concat(address.zip || '')), /*#__PURE__*/React.createElement("div", null, ((_address$country = address.country) === null || _address$country === void 0 ? void 0 : _address$country.name) || ''), /*#__PURE__*/React.createElement("div", {
    className: "pt-2"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/account/addresses/".concat(address.id),
    className: "btn editLink btn-primary btn-sm me-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-pen"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Edit"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return deleteAddress(address.id);
    },
    className: "btn btn-danger btn-sm"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-trash",
    className: "mr-2"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Delete"
  }))))));
};
export default Address;